/**
 * The switches the view has, as plain data with no renderer behind them.
 *
 * Its own module so the store can name them without importing `toThree` and with it
 * three.js: the store is read by the error boundary around every screen, and through it
 * the renderer used to ride into the entry chunk of every page — the terms and the
 * purchase screen included (`Root.tsx`). `toThree.ts` re-exports these.
 */

import type { Assembly } from "@planforge/wasm";

/**
 * What the eye groups the building into, which is not what the engine groups it
 * into. The model's `assembly` says *where* a piece is; a layer says *what it is* —
 * and "show me the framing" is a question about the second.
 */
export type LayerId = "framing" | "sheathing" | "siding" | "roofing" | "fixtures";

export const LAYERS: readonly LayerId[] = ["framing", "sheathing", "siding", "roofing", "fixtures"];

export const ASSEMBLIES: readonly Assembly[] = [
  "floor",
  "wall:front",
  "wall:back",
  "wall:left",
  "wall:right",
  "roof",
];
